import TranskipNilai from "../../../../../components/categories/siakad/lms/data_transkip_nilai/Home";
export default function Home() {
  
  return (
    <TranskipNilai />
  );
}
